var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-layout-box"},[_c('div',{staticClass:"main-layout-left"},[_c('Menu')],1),_c('div',{staticClass:"main-layout-right"},[_c('Header'),_c('transition',{attrs:{"enter-active-class":"fadeInUp","leave-active-class":"fadeOutDown","mode":"out-in"}},[_c('router-view')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }